export default __webpack_public_path__ + "assets/df373daa3475c7beac5ab63e6f75e64d.png";